export default __webpack_public_path__ + "static/media/remote.29d2dec8.png";